export default "__VITE_PUBLIC_ASSET__9ab687c7__"